/**
 * Include your custom JavaScript here.
 */
if (window.matchMedia("(max-width: 768px)").matches) {
    window.onscroll = function() {
        var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
            btn = document.getElementById('scrollToTop'),
            btnSupport = document.getElementsByClassName('support-floating')[0],
            priceList = document.getElementById("evolution-price-list");
        if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
        if (btnSupport && priceList) btnSupport.style.bottom = pageOffset > 1200 ? '65px': '15px';
    }
}

$(".block-swatch__radio, .variant-swatch__radio, .product-form__single-selector").change(function () {
  setTimeout(function () { parcelamento(); }, 150);
});

function increaseValue() {
  var value = parseInt(document.getElementById('number').value, 10);
  value = isNaN(value) ? 0 : value;
  value++;
  document.getElementById('number').value = value;
}

function decreaseValue() {
  var value = parseInt(document.getElementById('number').value, 10);
  value = isNaN(value) ? 0 : value;
  if(value !== 1) value--;
  document.getElementById('number').value = value;
}

$('.options:first-child').addClass('active')

$(".options").each(function() {
    $(this).on("click", function(){
        $('.options').removeClass('active')
        $(this).addClass('active')
        $('#evolution-price-list .price-promotional-wrap strong').html($(this).find('.valortot').text());
        $('#evolution-price-list .price-promotional-wrap span').html($(this).find('.valorcomp').text());
        $('#evolution-price-list .price-promotional-wrap .selector-desconto').remove();
        $('#evolution-price-list .price-promotional-wrap').append('<p class="selector-desconto">CUPOM ' + $(this).find('.saving').text() + ' APLICADO</p>');
        parcelamento();
    });
});

$(".product-form").each(function () {
    $(this).on('click', '.botaocmprar', function (event) {
        var arraydeprodutos = [];
        event.stopImmediatePropagation();
        var idproduto = parseInt($('.options.active .iddavariante').attr('val'))
        var qtdproduto = parseInt($('.options.active .iddavariante').attr('qtd'))
        arraydeprodutos.push({ id: idproduto, quantity: qtdproduto });
        $('.buy-together-list input').each(function () {
            if ($(this).prop("checked") === true) {
                arraydeprodutos.push({ id: $(this).attr("data-id"), quantity: 1 });
            }
        });
        data = { items: arraydeprodutos }
        $.ajax({
            type: 'POST', url: '/cart/add', data: data, dataType: 'json',
            success: function (data) {
                setTimeout(function () { window.location.href = '/cart' }, 500);
            }
        });
    });
});

function serialize(form) {
    function stringKey(key, value) {
        var beginBracket = key.lastIndexOf('[');
        if (beginBracket === -1) { var _hash = {}; _hash[key] = value; return _hash; }
        var newKey = key.substr(0, beginBracket);
        var newValue = {};
        newValue[key.substring(beginBracket + 1, key.length - 1)] = value;
        return stringKey(newKey, newValue);
    }
    var hash = {};
    for (var i = 0, len = form.elements.length; i < len; i++) {
        var formElement = form.elements[i];
        if (formElement.name === '' || formElement.disabled) { continue; }
        if (formElement.name && !formElement.disabled && (formElement.checked || /select|textarea/i.test(formElement.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(formElement.type))) {
            var stringKeys = stringKey(formElement.name, formElement.value);
            hash = extend(hash, stringKeys);
        }
    }
    return hash;
}

function extend() {
    var extended = {};
    var i = 0;
    var merge = function merge(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
                    extended[prop] = Form.extend(extended[prop], obj[prop]);
                } else { extended[prop] = obj[prop]; }
            }
        }
    };
    for (; i < arguments.length; i++) { merge(arguments[i]); }
    return extended;
}

const youtubeVideos = [...document.querySelectorAll('[data-youtube]')];
youtubeVideos.forEach(function(element) {
    const button = element.querySelector('[data-youtube-button]');
    button.addEventListener('click', function () {
        const url = event.target.dataset.youtubeButton;
        const youtubePlaceholder = event.target.parentNode;
        const htmlString = '<iframe width="100%" src="' + url + '?autoplay=1&showinfo=0&controls=1&rel=0&modestbranding=1" allow="autoplay;" frameborder="0" allowfullscreen></iframe>';
        youtubePlaceholder.style.display = 'none';
        youtubePlaceholder.insertAdjacentHTML('beforebegin', htmlString);
        youtubePlaceholder.parentNode.removeChild(youtubePlaceholder);
    });
});


// ---------------------------------------------------------------
// COLLINS SWATCH DATA
// All colors defined here so there is no 50-item Liquid limit.
// is_qse: true = Premium tier, false = Standard tier
// ---------------------------------------------------------------

var COLLINS_BASE_URL = 'https://cdn.shopify.com/s/files/1/0785/6029/7189/files/';

var COLLINS_VINYL_COLORS = [
  { label: 'Burgundy', file: 'oly-105-burgundy.png', is_qse: false },
  { label: 'Cadet', file: 'oly-110-cadet.png', is_qse: false },
  { label: 'Black', file: 'oly-115-black.png', is_qse: false },
  { label: 'Dove', file: 'oly-120-dove.png', is_qse: false },
  { label: 'Blue Ridge', file: 'oly-125-blue-ridge.png', is_qse: false },
  { label: 'American Beauty', file: 'oly-130-american-beauty.png', is_qse: false },
  { label: 'Turquoise', file: 'oly-135-turquoise.png', is_qse: false },
  { label: 'Cordovan', file: 'oly-140-cordovan.png', is_qse: false },
  { label: 'Deep Violet', file: 'oly-145-deep-violet.png', is_qse: false },
  { label: 'Raspberry', file: 'oly-150-raspberry.png', is_qse: false },
  { label: 'Hunter', file: 'oly-155-hunter.png', is_qse: false },
  { label: 'Regimental Blue', file: 'oly-160-regimental-blue.png', is_qse: false },
  { label: 'Lt Gray', file: 'oly-165-lt-gray.png', is_qse: false },
  { label: 'White', file: 'oly-170-white.png', is_qse: false },
  { label: 'Grotto', file: 'oly-175-grotto.png', is_qse: false },
  { label: 'Sand', file: 'oly-180-sand.png', is_qse: false },
  { label: 'Slate', file: 'oly-185-slate.png', is_qse: false },
  { label: 'Royal', file: 'oly-190-royal.png', is_qse: false },
  { label: 'New Burgundy', file: 'oly-195-new-burgundy.png', is_qse: false },
  { label: 'Crocus', file: 'oly-200-crocus.png', is_qse: false },
  { label: 'Graphite', file: 'oly-205-graphite.png', is_qse: false },
  { label: 'Cinnamon', file: 'oly-210-cinnamon.png', is_qse: false },
  { label: 'British Tan', file: 'oly-215-british-tan.png', is_qse: false },
  { label: 'Gingersnap', file: 'oly-220-gingersnap.png', is_qse: false },
  { label: 'Earth', file: 'oly-225-earth.png', is_qse: false },
  { label: 'Paprika', file: 'oly-225-paprika.png', is_qse: false },
  { label: 'Claret', file: 'oly-230-claret.png', is_qse: false },
  { label: 'Gunmetal', file: 'oly-235-gunmetal.png', is_qse: false },
  { label: 'River Rock', file: 'oly-240-river-rock.png', is_qse: false },
  { label: 'Desert', file: 'oly-245-desert.png', is_qse: false },
  { label: 'Basil', file: 'oly-250-basil.png', is_qse: false },
  { label: 'Java', file: 'oly-260-java.png', is_qse: false },
  { label: 'Bittersweet', file: 'oly-265-bittersweet.png', is_qse: false },
  { label: 'Desert Tan', file: 'oly-270-desert-tan.png', is_qse: false },
  { label: 'Oat', file: 'oly-275-oat.png', is_qse: false },
  { label: 'Suede', file: 'oly-280-suede.png', is_qse: false },
  { label: 'Majestic', file: 'oly-285-majestic.png', is_qse: false },
  { label: 'Lake', file: 'oly-290-lake.png', is_qse: false },
  { label: 'Ice Blue', file: 'oly-295-ice-blue.png', is_qse: false },
  { label: 'Tahiti', file: 'oly-300-tahiti.png', is_qse: false },
  { label: 'Leaf', file: 'oly-305-leaf.png', is_qse: false },
  { label: 'Honeydew', file: 'oly-310-honeydew.png', is_qse: false },
  { label: 'Sundance', file: 'oly-315-sundance.png', is_qse: false },
  { label: 'Pumpkin', file: 'oly-320-pumpkin.png', is_qse: false },
  { label: 'Aubergine', file: 'oly-325-aubergine.png', is_qse: false },
  { label: 'Red Berry', file: 'oly-330-red-berry.png', is_qse: false },
  { label: 'Chili Pepper', file: 'oly-335-chili-pepper.png', is_qse: false },
  { label: 'Pine Needle', file: 'oly-335-pine-needle.png', is_qse: false },
  { label: 'Cork', file: 'oly-340-cork.png', is_qse: false },
  { label: 'Cornsilk', file: 'oly-345-cornsilk.png', is_qse: false },
  { label: 'Orange Blast', file: 'oly-350-orange-blast.png', is_qse: false },
  { label: 'Oasis', file: 'oly-360-oasis.png', is_qse: false },
  { label: 'Purple Velvet', file: 'oly-365-purple-velvet.png', is_qse: false },
  { label: 'Spa', file: 'oly-370-spa.png', is_qse: false },
  { label: 'Tropic', file: 'oly-375-tropic.png', is_qse: false },
  { label: 'Breeze', file: 'oly-380-breeze.png', is_qse: false },
  { label: 'Canvas', file: 'oly-385-canvas.png', is_qse: false },
  { label: 'QSE Champagne', file: 'qse-champagne.png', is_qse: true },
  { label: 'QSE Flat Black', file: 'qse-flat-black.png', is_qse: true },
  { label: 'QSE Matrix White', file: 'qse-matrix-white.png', is_qse: true },
  { label: 'QSE Matte Black', file: 'qse-matte-black.png', is_qse: true },
  { label: 'QSE Saddle', file: 'qse-saddle.png', is_qse: true },
  { label: 'QSE Wallaby Black', file: 'qse-wallaby-black.png', is_qse: true },
  { label: 'QSE Wallaby Charcoal', file: 'qse-wallaby-charcoal.png', is_qse: true },
  { label: 'QSE Wallaby Chocolate', file: 'qse-wallaby-chocolate.png', is_qse: true },
  { label: 'QSE Wallaby Grey', file: 'qse-wallaby-grey.png', is_qse: true },
  { label: 'Sun Yellow', file: 'us-322-sun-yellow.png', is_qse: false },
  { label: 'Emerald', file: 'us-343-emerald.png', is_qse: false },
  { label: 'Forrest', file: 'us-344-forrest.png', is_qse: false },
  { label: 'Regimental Blue', file: 'us-345-regimental-blue.png', is_qse: false },
  { label: 'Yew Green', file: 'us-350-yew-green.png', is_qse: false },
  { label: 'Space Blue', file: 'us-353-space-blue.png', is_qse: false },
  { label: 'Royal', file: 'us-354-royal.png', is_qse: false },
  { label: 'Claret', file: 'us-357-claret.png', is_qse: false },
  { label: 'Tomato', file: 'us-358-tomato.png', is_qse: false },
  { label: 'American Beauty', file: 'us-360-american-beauty.png', is_qse: false },
  { label: 'Burgundy', file: 'us-364-burgundy.png', is_qse: false },
  { label: 'British Tan', file: 'us-365-british-tan.png', is_qse: false },
  { label: 'Gingersnap', file: 'us-369-gingersnap.png', is_qse: false },
  { label: 'Paprika', file: 'us-370-paprika.png', is_qse: false },
  { label: 'Mandarin Orange', file: 'us-372-mandarin-orange.png', is_qse: false },
  { label: 'Chestnut', file: 'us-375-chestnut.png', is_qse: false },
  { label: 'Terra Cotta', file: 'us-376-terra-cotta.png', is_qse: false },
  { label: 'Cinnamon', file: 'us-377-cinnamon.png', is_qse: false },
  { label: 'Mocha', file: 'us-381-mocha.png', is_qse: false },
  { label: 'Espresso', file: 'us-383-espresso.png', is_qse: false },
  { label: 'Sand', file: 'us-384-sand.png', is_qse: false },
  { label: 'Parchment', file: 'us-385-parchment.png', is_qse: false },
  { label: 'Camel', file: 'us-387-camel.png', is_qse: false },
  { label: 'Gunmetal', file: 'us-392-gunmetal.png', is_qse: false },
  { label: 'Black', file: 'us-393-black.png', is_qse: false },
  { label: 'Adobe White', file: 'us-394-adobe-white.png', is_qse: false },
  { label: 'Alabaster', file: 'us-396-alabaster.png', is_qse: false },
  { label: 'Putty', file: 'us-403-putty.png', is_qse: false },
  { label: 'Bone', file: 'us-404-bone.png', is_qse: false },
  { label: 'Bisque', file: 'us-409-bisque.png', is_qse: false },
  { label: 'Taupe', file: 'us-410-taupe.png', is_qse: false },
  { label: 'Dove', file: 'us-413-dove.png', is_qse: false },
  { label: 'Wedgewood', file: 'us-414-wedgewood.png', is_qse: false },
  { label: 'Dusty Jade', file: 'us-417-dusty-jade.png', is_qse: false },
  { label: 'Oak', file: 'us-421-oak.png', is_qse: false },
  { label: 'Greystone', file: 'us-425-greystone.png', is_qse: false },
  { label: 'Grotto', file: 'us-426-grotto.png', is_qse: false },
  { label: 'Blue Ridge', file: 'us-427-blue-ridge.png', is_qse: false },
  { label: 'Graphite', file: 'us-429-graphite.png', is_qse: false },
  { label: 'Imperial Blue', file: 'us-432-imperial-blue.png', is_qse: false },
  { label: 'Rosalee', file: 'us-504-rosalee.png', is_qse: false },
  { label: 'Dark Cherry', file: 'us-507-dark-cherry.png', is_qse: false },
  { label: 'Concord', file: 'us-510-concord.png', is_qse: false },
  { label: 'Deep Violet', file: 'us-511-deep-violet.png', is_qse: false },
  { label: 'Capri Blue', file: 'us-514-capri-blue.png', is_qse: false },
  { label: 'Sky Blue', file: 'us-516-sky-blue.png', is_qse: false },
  { label: 'Fjord Blue', file: 'us-517-fjord-blue.png', is_qse: false },
  { label: 'Doe', file: 'us-519-doe.png', is_qse: false },
  { label: 'Cinnabar', file: 'us-520-cinnabar.png', is_qse: false },
  { label: 'Bronze', file: 'us-523-bronze.png', is_qse: false },
  { label: 'Golden Corn', file: 'us-524-golden-corn.png', is_qse: false },
  { label: 'Sage', file: 'us-526-sage.png', is_qse: false },
  { label: 'Artichoke', file: 'us-527-artichoke.png', is_qse: false },
  { label: 'Olive Green', file: 'us-529-olive-green.png', is_qse: false },
  { label: 'Platinum', file: 'us-531-platinum.png', is_qse: false },
  { label: 'Admiral', file: 'us-532-admiral.png', is_qse: false },
  { label: 'Nebo', file: 'us-533-nebo.png', is_qse: false },
  { label: 'Orange Ochre', file: 'us-534-orange-ochre.png', is_qse: false },
  { label: 'Maple', file: 'us-535-maple.png', is_qse: false },
  { label: 'Russet', file: 'us-536-russet.png', is_qse: false }
];

var COLLINS_LAMINATE_COLORS = [
  { label: '5th Ave Elm', file: '5th-ave-elm-7966k-12.png' },
  { label: 'Ashen Ribbonwood', file: 'ashen-ribbonwood-8839-58.png' },
  { label: 'Asian Night', file: 'asian-night-7949k-18.png' },
  { label: 'Astro Strandz', file: 'astro-strandz-4940k-18.png' },
  { label: 'Black Alicante', file: 'black-alicante-4926k-07.png' },
  { label: 'Black Glossline', file: 'black-glossline-1595-28.png' },
  { label: 'Black Riftwood', file: 'black-riftwood-6414-ng.png' },
  { label: 'Black Velvet Traceless', file: 'black-velvet-traceless-15505-31.png' },
  { label: 'Bleached Legno', file: 'bleached-legno-8845-58.png', is_premium: true },
  { label: 'Boardwalk Oak', file: 'boardwalk-oak-7983-38.png' },
  { label: 'Branded Oak', file: 'branded-oak-8207k-16.png' },
  { label: 'Brazilwood', file: 'brazilwood-7946-38.png' },
  { label: 'Brighton Walnut', file: 'brighton-walnut-7922-07.png', is_premium: true },
  { label: 'Brushed Gold', file: 'brushed-gold-6261.png' },
  { label: 'Brushed Stainless', file: 'brushed-stainless-6256.png' },
  { label: 'Burnt Strand', file: 'burnt-strand-6307-58.png' },
  { label: 'Cafelle', file: 'cafelle-7933-07.png', is_premium: true },
  { label: 'Calcutta Marble', file: 'calcutta-marble-4925k-07.png' },
  { label: 'Chestnut Woodline', file: 'chestnut-woodline-5884-58.png' },
  { label: 'Cocoa Maple', file: 'cocoa-maple-7739-58.png' },
  { label: 'Columbian Walnut', file: 'columbian-walnut-7943k-07.png' },
  { label: 'Designer White', file: 'designer-white-solcor-d354-60.png' },
  { label: 'Earthen Twill', file: 'earthen-twill-8828-58.png' },
  { label: 'Ebony', file: 'ebony-9012-nt.png' },
  { label: 'Fusion Maple', file: 'fusion-maple-7909-60.png', is_premium: true },
  { label: 'Graphite Nebula', file: 'graphite-nebula-4623-60.png' },
  { label: 'Mangalore Mango', file: 'mangalore-mango-7984-38.png', is_premium: true },
  { label: 'Matrix White', file: 'matrix-white.png', is_premium: true },
  { label: 'Matte Black', file: 'matte-black-909-58.png', is_premium: true },
  { label: 'Matte Black', file: 'matte-black.png' },
  { label: 'Millennium Oak', file: 'millennium-oak-5887-nt.png' },
  { label: 'Morelia Mango', file: 'morelia-mango-7985-38.png', is_premium: true },
  { label: 'Oxidized Beamwood', file: 'oxidized-beamwood-9484-ng.png' },
  { label: 'Park Elm', file: 'park-elm-7967k-12.png' },
  { label: 'Platinum', file: 'platinum-902-58.png' },
  { label: 'Polished Concrete', file: 'polished-concrete-5022k-22.png' },
  { label: 'Portico Teak', file: 'portico-teak-8210k-28.png' },
  { label: 'Pumice', file: 'pumice-858-58.png' },
  { label: 'Saddle', file: 'saddle.png', is_premium: true },
  { label: 'Satin Stainless', file: 'satin-stainless-4830k-07.png' },
  { label: 'Sculpted Black', file: 'sculpted-black-909-sp.png' },
  { label: 'Sculpted Folkstone', file: 'sculpted-folkstone-927-sp.png' },
  { label: 'Sculpted White', file: 'sculpted-white-949-sp.png' },
  { label: 'Select Cherry', file: 'select-cherry-7759-43.png' },
  { label: 'Shaker Cherry', file: 'shaker-cherry-wc521.png', is_premium: true },
  { label: 'Slate Grey', file: 'slate-grey-d91-60.png' },
  { label: 'Smoky Brown Pear', file: 'smoky-brown-pear-5488-nt.png' },
  { label: 'Sterling Ash', file: 'sterling-ash-7995-38.png', is_premium: true },
  { label: 'Wallaby Black', file: 'wallaby-black.png' },
  { label: 'Wallaby Charcoal', file: 'wallaby-charcoal.png', is_premium: true },
  { label: 'Wallaby Chocolate', file: 'wallaby-chocolate.png', is_premium: true },
  { label: 'Wallaby Grey', file: 'wallaby-grey.png', is_premium: true },
  { label: 'Walnut Heights', file: 'walnut-heights-7965k-12.png' },
  { label: 'Walnut Riftwood', file: 'walnut-riftwood-9283-ng.png' },
  { label: 'Warehouse Oak', file: 'warehouse-oak-7969k-12.png' },
  { label: 'Weathered Beamwood', file: 'weathered-beamwood-6410-ng.png' },
  { label: 'Wenge Strand', file: 'wenge-strand-6306-58.png' },
  { label: 'White', file: 'white-949-58.png', is_premium: true },
  { label: 'White Cypress', file: 'white-cypress-7976k-12.png' },
  { label: 'White Twill', file: 'white-twill-9285-58.png', is_premium: true },
  { label: 'Wild Cherry', file: 'wild-cherry-7054-60.png', is_premium: true },
  { label: 'Witchcraft', file: 'witchcraft-wx421-h.png' },
  { label: 'Zanzibar', file: 'zanzibar-7957k-78.png' }
];

function buildSwatchHTML(colors, type) {
  return colors.map(function(color) {
    var imgUrl = COLLINS_BASE_URL + color.file;
    var tier = color.is_qse ? 'Premium' : 'Standard';
    var laminateTier = color.is_premium ? 'Premium' : 'Standard';
    var dataAttr = type === 'vinyl'
      ? 'data-color="' + color.label.replace(/"/g, '&quot;') + '" data-tier="' + tier + '"'
      : 'data-laminate="' + color.label.replace(/"/g, '&quot;') + '" data-laminate-tier="' + laminateTier + '"';
    return '<div class="color-swatch collins-swatch">' +
      '<button type="button" class="color-swatch__item collins-swatch__button" ' +
      'title="' + color.label.replace(/"/g, '&quot;') + '" ' +
      'aria-label="' + color.label.replace(/"/g, '&quot;') + '" ' +
      dataAttr + ' ' +
      'style="background-image:url(' + imgUrl + '); background-size:cover; background-position:center;">' +
      '<span class="visually-hidden">' + color.label + '</span>' +
      '</button></div>';
  }).join('');
}

document.addEventListener('DOMContentLoaded', function() {
  // Replace vinyl swatch list contents
  var vinylList = document.querySelector('[data-selector-type="collins-vinyl"] .collins-swatch-list');
  if (vinylList) {
    vinylList.innerHTML = buildSwatchHTML(COLLINS_VINYL_COLORS, 'vinyl');
  }

  // Replace laminate swatch list contents
  var laminateList = document.querySelector('[data-selector-type="collins-laminate"] .collins-swatch-list');
  if (laminateList) {
    laminateList.innerHTML = buildSwatchHTML(COLLINS_LAMINATE_COLORS, 'laminate');
  }
});


document.addEventListener('click', function (e) {

  // ---------------------------------------------------------------
  // VINYL swatch
  // ---------------------------------------------------------------
  const vinylButton = e.target.closest('.collins-swatch__button[data-color]');

  if (vinylButton) {
    const color = vinylButton.getAttribute('data-color');
    const tier  = vinylButton.getAttribute('data-tier');

    const selectedColorInput = document.getElementById('selected-color');
    if (selectedColorInput) selectedColorInput.value = color;

    const selectedColorText = document.getElementById('collins-selected-color');
    if (selectedColorText) selectedColorText.textContent = color;

    document.querySelectorAll('.collins-swatch__button[data-color]').forEach(function (btn) {
      btn.classList.remove('is-active');
    });
    vinylButton.classList.add('is-active');

    const productData = JSON.parse(document.querySelector('[data-product-json]').textContent);
    const product = productData.product;

    const variantIdInput = document.querySelector('input[name="id"], select[name="id"]');
    const liveVariantId = variantIdInput ? parseInt(variantIdInput.value, 10) : productData.selected_variant_id;

    const currentVariant = product.variants.find(function(v) {
      return v.id === liveVariantId;
    });

    if (!currentVariant) return;

    const targetVariant = product.variants.find(function(v) {
      return product.options.every(function(optName, i) {
        const optKey = 'option' + (i + 1);
        if (optName.toLowerCase() === 'tier') return v[optKey] === tier;
        return v[optKey] === currentVariant[optKey];
      });
    });

    if (targetVariant) {
      if (variantIdInput) {
        variantIdInput.value = targetVariant.id;
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      window.history.replaceState({ variantId: targetVariant.id }, '', window.location.pathname + '?variant=' + targetVariant.id);

      document.documentElement.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true,
        detail: { variant: targetVariant }
      }));

      var priceEl = document.querySelector('#evolution-price-list .price-promotional-wrap strong');
      if (priceEl && targetVariant.price) {
        priceEl.textContent = (targetVariant.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      }

      var addBtn = document.querySelector('.product-form__add-button');
      if (addBtn) {
        if (targetVariant.available) {
          addBtn.removeAttribute('disabled');
          addBtn.classList.remove('button--disabled');
          addBtn.textContent = 'Add to cart';
        } else {
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.classList.add('button--disabled');
          addBtn.textContent = 'Sold out';
        }
      }
    }
  }

  // ---------------------------------------------------------------
  // LAMINATE swatch — switches Laminate Tier variant (Standard/Premium)
  // same approach as vinyl, preserving all other options
  // ---------------------------------------------------------------
  const laminateButton = e.target.closest('.collins-swatch__button[data-laminate]');

  if (laminateButton) {
    const laminate = laminateButton.getAttribute('data-laminate');
    const laminateTier = laminateButton.getAttribute('data-laminate-tier') || 'Standard';

    // Write to hidden line-item property
    const selectedLaminateInput = document.getElementById('selected-laminate');
    if (selectedLaminateInput) selectedLaminateInput.value = laminate;

    // Update visible label
    const selectedLaminateText = document.getElementById('collins-selected-laminate');
    if (selectedLaminateText) selectedLaminateText.textContent = laminate;

    // Toggle active class
    document.querySelectorAll('.collins-swatch__button[data-laminate]').forEach(function (btn) {
      btn.classList.remove('is-active');
    });
    laminateButton.classList.add('is-active');

    // Switch variant based on Laminate Tier — same logic as vinyl
    var productJsonEl = document.querySelector('[data-product-json]');
    if (!productJsonEl) return;

    const productData = JSON.parse(productJsonEl.textContent);
    const product = productData.product;
    const variantIdInput = document.querySelector('input[name="id"], select[name="id"]');
    const liveVariantId = variantIdInput ? parseInt(variantIdInput.value, 10) : productData.selected_variant_id;

    const currentVariant = product.variants.find(function(v) {
      return v.id === liveVariantId;
    });

    if (!currentVariant) return;

    // Find variant matching laminate tier, preserving all other options
    const targetVariant = product.variants.find(function(v) {
      return product.options.every(function(optName, i) {
        const optKey = 'option' + (i + 1);
        if (optName.toLowerCase() === 'laminate tier') return v[optKey] === laminateTier;
        return v[optKey] === currentVariant[optKey];
      });
    });

    if (targetVariant) {
      if (variantIdInput) {
        variantIdInput.value = targetVariant.id;
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      window.history.replaceState({ variantId: targetVariant.id }, '', window.location.pathname + '?variant=' + targetVariant.id);

      document.documentElement.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true,
        detail: { variant: targetVariant }
      }));

      var priceEl = document.querySelector('#evolution-price-list .price-promotional-wrap strong');
      if (priceEl && targetVariant.price) {
        priceEl.textContent = (targetVariant.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      }

      var addBtn = document.querySelector('.product-form__add-button');
      if (addBtn) {
        if (targetVariant.available) {
          addBtn.removeAttribute('disabled');
          addBtn.classList.remove('button--disabled');
          addBtn.textContent = 'Add to cart';
        } else {
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.classList.add('button--disabled');
          addBtn.textContent = 'Sold out';
        }
      }
    }
  }

});